import { z } from 'zod';
import { nonNegativeInt, nonNegativeNumber, optionalUuidString } from '../zod-helpers/index.js';
import { PART_CONSTRAINTS } from './constraints.js';
import { partUrlSchema } from './part-url.js';
export const updatePartInputSchema = z.object({
    name: z.string().trim().max(PART_CONSTRAINTS.name.maxLength).optional().nullable(),
    description: z
        .string()
        .trim()
        .max(PART_CONSTRAINTS.description.maxLength, `${PART_CONSTRAINTS.description.label} is too long.`)
        .optional()
        .nullable(),
    revision: z.string().max(PART_CONSTRAINTS.revision.maxLength).optional().nullable(),
    controlledFlag: z.boolean().optional(),
    stdCost: nonNegativeNumber(PART_CONSTRAINTS.stdCost.label).optional().nullable(),
    leadTime: nonNegativeInt(PART_CONSTRAINTS.leadTime.label).optional().nullable(),
    // Identifiers
    upc: z
        .string()
        .trim()
        .max(PART_CONSTRAINTS.upc.maxLength)
        .regex(/^\d*$/, 'UPC must contain digits only.')
        .optional()
        .nullable(),
    url: partUrlSchema.optional().nullable(),
    alertNote: z.string().trim().max(PART_CONSTRAINTS.alertNote.maxLength).optional().nullable(),
    abcCode: z
        .string()
        .trim()
        .transform((value) => value.toUpperCase())
        .refine((value) => value === '' || ['A', 'B', 'C'].includes(value), {
        message: 'ABC code must be A, B, or C.',
    })
        .optional()
        .nullable(),
    // Physical
    weight: nonNegativeNumber(PART_CONSTRAINTS.weight.label).optional().nullable(),
    weightUomId: optionalUuidString('Invalid weight UOM selection.').optional().nullable(),
    len: nonNegativeNumber(PART_CONSTRAINTS.len.label).optional().nullable(),
    width: nonNegativeNumber(PART_CONSTRAINTS.width.label).optional().nullable(),
    height: nonNegativeNumber(PART_CONSTRAINTS.height.label).optional().nullable(),
    sizeUomId: optionalUuidString('Invalid size UOM selection.').optional().nullable(),
    // Operational
    receivingTol: nonNegativeNumber(PART_CONSTRAINTS.receivingTol.label).optional().nullable(),
    // Bounded like setPartStockSetup's sibling: the same column gates the count-variance register,
    // and a tolerance above 100% would silently switch it off for the part.
    cycleCountTol: nonNegativeNumber(PART_CONSTRAINTS.cycleCountTol.label)
        .max(PART_CONSTRAINTS.cycleCountTol.max, PART_CONSTRAINTS.cycleCountTol.maxMessage)
        .optional()
        .nullable(),
    taxId: optionalUuidString('Invalid tax rate selection.').optional().nullable(),
    // Accounting — gated on part:accounting in the resolver
    inventoryAccountId: optionalUuidString('Invalid inventory account.').optional().nullable(),
    cogsAccountId: optionalUuidString('Invalid COGS account.').optional().nullable(),
    varianceAccountId: optionalUuidString('Invalid variance account.').optional().nullable(),
    scrapAccountId: optionalUuidString('Invalid scrap account.').optional().nullable(),
    adjustmentAccountId: optionalUuidString('Invalid adjustment account.').optional().nullable(),
});
//# sourceMappingURL=update-input.js.map